import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    data: null,
    status: false
};

const updateConfirmation = (state, action) => {
    return updateObject(state, {
        data: action.data
    });
};

const updateSignUpStatus = (state, action) => {
    return updateObject(state, {
        status: action.status
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_CONFIRMATION:
            return updateConfirmation(state, action);
        case actionTypes.FETCH_SIGN_UP_STATUS:
            return updateSignUpStatus(state, action);
        case actionTypes.UPDATE_SIGN_UP_STATUS:
            return updateSignUpStatus(state, action);
        default:
            return state;
    }
};

export default reducer;
